import { Shield, Wrench, Zap, BatteryCharging, Star, HeadphonesIcon } from "lucide-react";

const features = [
  {
    icon: Shield,
    title: "Advanced Safety",
    desc: "Seat belts, obstruction sensors, emergency stop & smooth start-stop ensure secure stair travel.",
  },
  {
    icon: Wrench,
    title: "Custom-Made Fit",
    desc: "Tailored for straight, curved & outdoor staircases. Perfect fit for every home layout.",
  },
  {
    icon: Zap,
    title: "Whisper-Quiet",
    desc: "Advanced motor technology for smooth, silent gliding. No jolts, no jerks.",
  },
  {
    icon: BatteryCharging,
    title: "Battery Backup",
    desc: "Works even during power cuts. Continuous mobility you can rely on.",
  },
  {
    icon: Star,
    title: "Ergonomic Comfort",
    desc: "Plush padded seating with armrests & footrests. Gentle rides for seniors.",
  },
  {
    icon: HeadphonesIcon,
    title: "Lifetime Support",
    desc: "Quick installation in 1-2 days with reliable after-sales service across India.",
  },
];

export default function WhyChoose() {
  return (
    <section data-testid="why-choose-section" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left - Image */}
          <div className="hidden lg:block">
            <img
              src="https://vingrace.in/wp-content/uploads/2025/12/Platinum-Ergo-Straight-Stair-Lift3-1024x1024.webp"
              alt="Platinum Ergo Straight Stair Lift"
              className="rounded-2xl w-full max-w-md mx-auto"
              loading="lazy"
            />
          </div>

          {/* Right - Features */}
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#b22300] mb-3">Why Vin Grace</p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-stone-900 font-['Outfit']">
              Why 8,000+ Families Trust Us
            </h2>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {features.map((f, i) => (
                <div
                  key={f.title}
                  data-testid={`feature-card-${i}`}
                  className="flex items-start gap-3 p-4 rounded-xl border border-stone-100 hover:border-stone-200 hover:shadow-sm transition-all"
                >
                  <div className="w-9 h-9 rounded-lg bg-red-50 flex items-center justify-center flex-shrink-0">
                    <f.icon className="w-4 h-4 text-[#b22300]" />
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-stone-900 font-['Outfit']">{f.title}</h3>
                    <p className="text-stone-500 text-xs mt-1 leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Google Reviews Widget */}
            <div data-testid="google-reviews-widget" className="mt-6 rounded-xl border border-amber-200 bg-amber-50/50 p-4 flex items-center gap-4">
              <div className="flex items-center gap-1">
                {[1,2,3,4].map(i => (
                  <svg key={i} className="w-5 h-5 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
                <svg className="w-5 h-5 text-amber-500" viewBox="0 0 20 20">
                  <defs><linearGradient id="halfStar2"><stop offset="50%" stopColor="currentColor"/><stop offset="50%" stopColor="#d6d3d1"/></linearGradient></defs>
                  <path fill="url(#halfStar2)" d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                </svg>
              </div>
              <div>
                <p className="text-stone-900 font-semibold text-sm font-['Outfit']">4.5 / 5 on Google</p>
                <p className="text-stone-500 text-xs">Based on 112 Reviews</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
